<template>
  <div ref="target" class="news-list">
    <div class="left">
      <div class="top">
        <div class="top-carousel">
          <NewsCarousel :bannerList="bannerList" />
          <SubmainList :domainList="domainList" />
        </div>
      </div>
      <div class="bottom">
        <NewsVideo :list="list" />
      </div>
    </div>
    <div class="middle">
      <PolicyNews :policyList="policyList" :domainList="domainList" />
    </div>
    <div class="right">
      <NoticeNews :noticeList="noticeList" :domainList="domainList" />
      <div class="notes">
        <NewsTests :testList="testList" />
      </div>
    </div>
  </div>
</template>

<script>
import SubmainList from "../common/submain-list.vue";
import NewsVideo from "../newsvideo/news-video.vue";
import NewsTests from "../newstests/news-tests.vue";
import NewsCarousel from "../common/new-carousel.vue";
import PolicyNews from "../common/policy-news.vue";
import NoticeNews from "../common/notice-news.vue";
import { ref, computed } from "vue";
import { findNewsVideo, findNewsTests } from "@/api/news";
import { useLazyData } from "@/hooks/index";
import { useStore } from "vuex";

export default {
  components: {
    NewsVideo,
    NewsTests,
    NewsCarousel,
    SubmainList,
    PolicyNews,
    NoticeNews,
  },
  props: {
    policyList: {
      type: Object,
      default: () => {},
    },
    noticeList: {
      type: Object,
      default: () => {},
    },
    bannerList: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const store = useStore();
    const target = ref(null);
    const clID = ref(2906);
    const { result } = useLazyData(target, () =>
      findNewsVideo({ clID: [clID.value] })
    );

    const { testList } = useLazyData(target, () =>
      findNewsTests({ clID: [clID.value] })
    );
    const domainList = computed(() => {
      let list = store.state.category.list.find(
        (items) => items.clID === clID.value
      );
      return list;
    });
    return {
      clID,
      list: result,
      testList,
      target,
      NewsVideo,
      domainList,
    };
  },
};
</script>

<style lang="less" scoped>
.news-list {
  height: 500px;
  //background: #f0e5e5;
  display: flex;
  justify-content: space-between;
  .left {
    width: 400px;
    height: 500px;
    display: flex;
    flex-direction: column;
    .top {
      width: 400px;
      height: 240px;
      .top-carousel {
        display: inline-block;
        width: 360px;
        height: 130px;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 15px;
        border-radius: 5px;
      }
    }

    .bottom {
      width: 400px;
      height: 250px;
    }
  }
  .middle {
    margin-top: 15px;
    width: 400px;
    overflow: hidden;
    border: 1px solid rgb(244, 244, 244);
  }
  .right {
    margin-top: 15px;
    width: 400px;

    .notes {
    }
  }
}
</style>
